<template>
    <div class="audit_root google_root_bind">
        <Top></Top>
        <div class="audit_body___1UbSf">
            <div class="side-menu-layout">
                <div class="content_main">
                    <div class="ant-spin-nested-loading">
                        <div class="ant-spin-container">
                            <div class="ant-card pesonalKyc___UZUEa ant-card-bordered ant-card-wider-padding ant-card-padding-transition">
                                <div class="ant-card-head">
                                    <div class="ant-card-head-wrapper">
                                        <div class="ant-card-head-title">
                                            <div class="cardTitle___1SbxV">
                                                <a @click="changeRoute('/my')">
                                                    <img src="@/assets/img/left_blue.png" alt="">
                                                    <span>{{ $t('m.my.safe.login.text[0]') }}</span>
                                                </a>
                                                <span v-if="userInfo.is_google == 0" class="cmpt_ct_title___3zPlz">{{ $t('m.my.safe.google.title[0]') }}</span>
                                                <span v-else class="cmpt_ct_title___3zPlz">{{ $t('m.my.safe.google.title[1]') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ant-card-body">
                                    <div class="ant-form ant-form-horizontal formWrapper___XJCyu" v-if="!next.show">
                                        <div class="formTitle___1a-ZI">{{ $t('m.my.safe.google.text[0]') }}</div>
                                        <div class="formBody___-reP3">
                                            <!--<div class="ant-row ant-form-item undefined form_item___y-3Yn"-->
                                                 <!--style="height: 60px">-->
                                                <!--<div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">-->
                                                    <!--<label for="my_sms">{{ $t('m.my.safe.phone.text[2]') }}:</label>-->
                                                <!--</div>-->
                                                <!--<div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">-->
                                                    <!--<div class="ant-form-item-control">-->
                                                        <!--<span class="ant-form-item-children">-->
                                                            <!--<div id="my_sms" style="height: 32px">-->
                                                                <!--<span class="ant-input-group-wrapper"-->
                                                                      <!--style="height: 32px">-->
                                                                    <!--<span class="ant-input-wrapper ant-input-group"-->
                                                                          <!--style="height: 32px">-->
                                                                        <!--<span class="ant-input-group-addon"-->
                                                                              <!--@click="getNote2()">-->
                                                                            <!--<div>-->
                                                                                <!--<span class="ms_sendBtn___1xgkG"-->
                                                                                      <!--style="pointer-events: all;"-->
                                                                                      <!--v-if="expire.show == 0">{{ $t('m.my.safe.google.email[1]') }}</span>-->
                                                                                <!--<span class="ms_sendBtn___1xgkG"-->
                                                                                      <!--style="pointer-events: all;"-->
                                                                                      <!--v-else-if="expire.show == 2">{{ $t('m.my.safe.google.email[2]') }}</span>-->
                                                                                <!--<span class="ms_sendBtn___1xgkG"-->
                                                                                      <!--style="pointer-events: all;"-->
                                                                                      <!--v-else>{{ expire.time }}</span>-->
                                                                            <!--</div>-->
                                                                        <!--</span>-->
                                                                        <!--<input type="text"-->
                                                                               <!--class="ant-input kc-input kc-input-send"-->
                                                                               <!--maxlength="6"-->
                                                                               <!--:placeholder="$t('m.my.safe.phone.text[2]')"-->
                                                                               <!--style="height: 32px;"-->
                                                                               <!--v-model="next.code">-->
                                                                    <!--</span>-->
                                                                <!--</span>-->
                                                            <!--</div>-->
                                                        <!--</span>-->
                                                    <!--</div>-->
                                                <!--</div>-->
                                            <!--</div>-->
                                            <!--验证方式-->
                                            <div class="adv-data overflow">
                                                <div class="adv-left v-left" style="font-size: 12px;color:#9194a4 ;margin-bottom: 5px">{{ $t('m.common.check')[0] }}</div>
                                                <div class="adv-right">
                                                    <Select v-model="check_type" :placeholder="$t('m.common.check')[1]">
                                                        <!--<Option v-show="userInfo.is_google" :value="1">
                                                            {{ $t('m.common.check')[2] }}
                                                        </Option>-->
                                                        <Option v-show="userInfo.mobile" :value="2">
                                                            {{ $t('m.common.check')[3] }}
                                                        </Option>
                                                        <Option v-show="userInfo.email" :value="3">
                                                            {{ $t('m.common.check')[4] }}
                                                        </Option>
                                                    </Select>
                                                </div>
                                            </div>
                                            <!--谷歌验证码-->
                                            <!--<div class="adv-data overflow" v-show="check_type == 1">
                                                <div class="adv-left v-left" style="font-size: 12px;color:#9194a4 ;margin-bottom: 5px">{{ $t('m.common.check')[5] }}</div>
                                                <div class="adv-right">
                                                    <div style="position: relative;">
                                                        <Input v-model="request.code" :placeholder="$t('m.common.check')[6]"/>
                                                        &lt;!&ndash;<button class="authBtn" @click="time()">{{$t('m.otctrade.btn.commit')[1]}}</button>&ndash;&gt;
                                                    </div>
                                                </div>
                                            </div>-->
                                            <!--手机验证码-->
                                            <div class="adv-data overflow" v-show="check_type == 2">
                                                <div class="adv-left v-left" style="font-size: 12px;color:#9194a4 ;margin-bottom: 5px">{{ $t('m.common.check')[7] }}</div>
                                                <div class="adv-right">
                                                    <div style="position: relative;">
                                                        <Input v-model="request.code" :placeholder="$t('m.common.check')[8]"/>
                                                        <button class="authBtn" @click="sendMsg(1)" v-if="expire.show == 0">
                                                            {{ $t('m.common.check')[9] }}
                                                        </button>
                                                        <button class="authBtn" v-else-if="expire.show == 2">
                                                            {{ $t('m.common.check')[10] }}
                                                        </button>
                                                        <button class="authBtn" v-else>{{ expire.time }} S</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--邮箱验证码-->
                                            <div class="adv-data overflow" v-show="check_type == 3">
                                                <div class="adv-left v-left" style="font-size: 12px;color:#9194a4 ;margin-bottom: 5px">{{ $t('m.common.check')[11] }}</div>
                                                <div class="adv-right">
                                                    <div style="position: relative;">
                                                        <Input v-model="request.code" :placeholder="$t('m.common.check')[12]"/>
                                                        <button class="authBtn" @click="sendMsg(2)" v-if="expire.show == 0">
                                                            {{ $t('m.common.check')[9] }}
                                                        </button>
                                                        <button class="authBtn" v-else-if="expire.show == 2">
                                                            {{ $t('m.common.check')[10] }}
                                                        </button>
                                                        <button class="authBtn" v-else>{{ expire.time }} S</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ant-btn  kc-button ant-btn-primary ant-btn-block"
                                                 style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);width: 280px;line-height: 32px"
                                                 @click="nextStep()">{{ $t('m.my.safe.google.text[1]') }}
                                            </div>
                                        </div>
                                        <!--<div class="formBody___-reP3" v-show="step == 2">
                                            <div class="ant-row ant-form-item undefined form_item___y-3Yn"
                                                 style="height: 60px">
                                                <div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">
                                                    <label for="my_sms">{{ $t('m.my.safe.google.email[0]') }}:</label>
                                                </div>
                                                <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                                    <div class="ant-form-item-control">
                                                        <span class="ant-form-item-children">
                                                            <div id="my_sms" style="height: 32px">
                                                                <span class="ant-input-group-wrapper"
                                                                      style="height: 32px">
                                                                    <span class="ant-input-wrapper ant-input-group"
                                                                          style="height: 32px">
                                                                        <span class="ant-input-group-addon"
                                                                              @click="getNote()">
                                                                            <div>
                                                                                <span class="ms_sendBtn___1xgkG"
                                                                                      style="pointer-events: all;"
                                                                                      v-if="expireEmail.show == 0">{{ $t('m.my.safe.google.email[1]') }}</span>
                                                                                <span class="ms_sendBtn___1xgkG"
                                                                                      style="pointer-events: all;"
                                                                                      v-else-if="expireEmail.show == 2">{{ $t('m.my.safe.google.email[2]') }}</span>
                                                                                <span class="ms_sendBtn___1xgkG"
                                                                                      style="pointer-events: all;"
                                                                                      v-else>{{ expireEmail.time }}</span>
                                                                            </div>
                                                                        </span>
                                                                        <input type="text"
                                                                               class="ant-input kc-input kc-input-send"
                                                                               maxlength="6"
                                                                               :placeholder="$t('m.my.safe.google.email[0]')"
                                                                               style="height: 32px;"
                                                                               v-model="next.node">
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ant-btn  kc-button ant-btn-primary ant-btn-block"
                                                 style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);width: 280px;line-height: 32px"
                                                 @click="nextStep()">{{ $t('m.my.safe.google.text[1]') }}
                                            </div>
                                        </div>-->
                                    </div>
                                    <div class="ant-form ant-form-horizontal formWrapper___XJCyu" v-else>
                                        <div class="formTitle___1a-ZI">{{ $t('m.my.safe.google.title[2]') }}</div>
                                        <!--<div class="ant-alert ant-alert-warning tip___2TVQs ">
                                            <img src="@/assets/img/zhuyi_orange.png" alt="">
                                            <span class="ant-alert-message">
                                                详情信息请阅读 <u>谷歌验证指南</u>
                                            </span>
                                        </div>-->
                                        <div class="formBody___-reP3">
                                            <div class="ant-row ant-form-item" style="height: 138px">
                                                <div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">
                                                    <label>{{ $t('m.my.safe.google.text[2]') }}</label>
                                                </div>
                                                <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                                    <div class="ant-form-item-control">
                                                        <span class="ant-form-item-children">
                                                            <div class="g2faCode___h-D3X">
                                                                <canvas style="height: 92px; width: 92px;"
                                                                        id="canvas-google-code"></canvas>
                                                                <div class="code___85Xf9">
                                                                    <div>{{ google.secret }}</div>
                                                                    <div class="copy"
                                                                         v-clipboard:copy="google.secret"
                                                                         v-clipboard:success="doClipboard"
                                                                         v-clipboard:error="">复制</div>
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ant-row ant-form-item" style="height: 60px">
                                                <div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">
                                                    <label for="code">{{ $t('m.my.safe.google.text[3]') }}:</label>
                                                </div>
                                                <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                                    <div class="ant-form-item-control">
                                                        <span class="ant-form-item-children">
                                                            <input type="text" id="code" class="ant-input kc-input"
                                                                   style="height: 32px" v-model="code">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ant-btn  kc-button ant-btn-primary ant-btn-block"
                                                 style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);width: 280px;line-height: 32px"
                                                 @click="verify()">{{ $t('m.my.safe.google.text[4]') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'
    import QRCode from 'qrcode';

    export default {
        name: "audit",
        components: {
            Top, Bottom
        },
        data() {
            return {
                active: 'safe',
                next: {
                    show: false,
                    code: '',
                    node: ''
                },
                /*expire: {
                    show: 0, //0为发送，1发送成功，2发送中
                    time: 60
                },
                expireEmail: {
                    show: 0, //0为发送，1发送成功，2发送中
                    time: 60
                },*/
                google: {
                    qrcode: "",
                    secret: ""
                },
                code: "",
                // step: 1,
                check_type: '',
                expire: {
                    show: 0, //0为发送，1发送成功，2发送中
                    time: 60
                },
                request: {
                    code: ""
                },
            }
        },
        created() {
            if (!this.userInfo.email || !this.userInfo.mobile) {
                this.$confirm(this.$t('m.my.safe.alert[0]'), this.$t('m.component.deal.middle.alert[1]'), {
                    confirmButtonText: this.$t('m.my.safe.alert[2]'),
                    cancelButtonText: this.$t('m.my.safe.alert[3]'),
                    type: 'warning',
                    center: true
                }).then(() => {
                    if (!this.userInfo.mobile) {
                        this.changeRoute('/new_phone');
                    } else {
                        this.changeRoute('/new_email');
                    }
                }).catch(() => {
                    console.log(333);
                    this.changeRoute('/my');
                });
            }
        },
        mounted() {
            // this.getCode();
        },
        methods: {
            sendMsg(type) {
                if (type == 1) {
                    // 发送手机验证码
                    if (this.expire.show) return;
                    this.expire.show = 2;
                    let paramData = {
                      nationality: Number(this.userInfo.nationality),
                      mobile: this.userInfo.mobile,
                      type: 3
                    };
                    paramData.signature = this.signature(paramData);
                    this.$axios.post(this.requestConfig.host + "/index/Login/sendSms", paramData).then((res) => {
                        res.cbkE = ()=> this.expire.show = 0;
                        return this.checkResponse(res);
                    }).then((res) => {
                        this.expire = {
                            show: 1,
                            time: 60
                        };
                        let it = setInterval(() => {
                            if (this.expire.time >= 1) {
                                this.expire.time--;
                            } else {
                                clearInterval(it);
                                this.expire.show = false;
                            }
                        }, 1000);
                    }).then((res) => {
                        this.$message.success(this.$t('m.common.my.mobile[0]'));
                    }).catch((e) => {

                    })
                } else {
                    // 发送邮箱验证码
                    if (this.expire.show) return;
                    this.expire.show = 2;
                    let paramData = {
                      email: this.userInfo.email,
                      type: 3
                    };
                    paramData.signature = this.signature(paramData);
                    this.$axios.post(this.requestConfig.host + "/index/Login/noteEmail", paramData).then((res) => {
                        res.cbkE = ()=> this.expire.show = 0;
                        return this.checkResponse(res);
                    }).then((res) => {
                        this.expire = {
                            show: 1,
                            time: 60
                        };
                        let it = setInterval(() => {
                            if (this.expire.time >= 1) {
                                this.expire.time--;
                            } else {
                                clearInterval(it);
                                this.expire.show = false;
                            }
                        }, 1000);
                    }).then((res) => {
                        this.$message.success(this.$t('m.common.my.email[0]'));
                    }).catch((e) => {

                    })
                }
            },
            nextStep: function () {
                if (this.check_type == '') {
                    this.$message.error(this.$t('m.common.check')[1]);
                    return;
                }
                if (this.request.code == '' && this.check_type == '2') {
                    this.$message.error(this.$t('m.common.check')[8]);
                    return;
                }
                if (this.request.code == '' && this.check_type == '3') {
                    this.$message.error(this.$t('m.common.check')[12]);
                    return;
                }
                if (this.check_type == '2') {
                  let paramData = {
                    mobile: this.userInfo.mobile,
                    code: this.request.code,
                    type: 3
                  };
                  paramData.signature = this.signature(paramData);
                    this.$axios.post(this.requestConfig.host + "/index/Login/checkCode", paramData).then((res) => {
                        return this.checkResponse(res);
                    }).then((res) => {
                        this.next.show = true;
                        this.getCode();
                    }).catch((e) => {
                        if (e == 20001) return;
                        this.$message.error(e);
                    })
                } else {
                  let paramData = {
                    note: this.request.code,
                    email: this.userInfo.email,
                    type: 3
                  };
                  paramData.signature = this.signature(paramData);
                    this.$axios.post(this.requestConfig.host + "/index/Login/checkNote", paramData).then((res) => {
                        return this.checkResponse(res);
                    }).then(() => {
                        this.next.show = true;
                        this.getCode();
                    }).catch((e) => {
                        if (e == 20001) return;
                        this.$message.error(e);
                    })
                }
            },
            doClipboard: function () {
                this.$message.success(this.$t('m.assets.text[40]'));
            },
            getCode: function () {
                let paramData = { };
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Google/generate?token=" + this.userInfo.key, paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.google = res;
                    this.showQrcode();
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    // this.aMyAlert({show: true, msg: e});
                    this.$message.error(e);
                })
            },
            showQrcode: function () {
                let canvas = document.querySelector('#canvas-google-code');
                QRCode.toCanvas(canvas, this.google.qrcode, {
                    width: 92,
                    margin: 0
                }, function (error) {
                    if (error)
                        console.log(error)
                })
            },
            verify() {
                let paramData = {
                  code: this.code,
                  type : 3
                };
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Google/verify?token=" + this.userInfo.key, paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.$message.success(this.$t('m.common.my.google[2]'));
                    this.aUserInfo({is_google: 1});
                    setTimeout(() => {
                        this.changeRoute("/my")
                    }, 1200);
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    this.$message.error(e);
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../assets/css/audit.css";
    .google_root_bind {
        .ivu-input:focus {
            border-color: #57a3f3!important;
        }
        .adv-data {
            margin-bottom: 15px;
            font-size: 14px;
            .ivu-select-single {
                .ivu-select-selection {
                    height: 36px;
                    position: relative;
                    .ivu-select-placeholder, .ivu-select-selected-value {
                        height: 36px;
                        line-height: 36px;
                        font-size: 14px;
                        padding-left: 15px;
                    }
                }
            }
            .ivu-select-item {
                font-size: 14px !important;
            }
            .ivu-input {
                height: 36px;
                line-height: 36px;
                font-size: 14px;
                padding-left: 15px;
            }
            .ivu-checkbox-wrapper {
                margin-right: 80px;
                height: 36px;
                line-height: 36px;
                font-size: 14px;
                .ivu-checkbox {
                    margin-right: 8px;
                    .ivu-checkbox-inner {
                        width: 15px;
                        height: 15px;
                    }
                }
            }
            .authBtn {
                position: absolute;
                right: 10px;
                top: 6px;
                text-align: center;
                font-size: 13px;
                border: none;
                border-left: 1px solid #d1d3df;
                height: 24px;
                text-indent: 0;
                color: #357ce1;
                background-color: transparent;
                cursor: pointer;
                outline: none;
                /*padding-left: 10px;*/
                width: 100px;
            }
            .adv-btn {
                width: 100%;
                font-size: 16px;
                padding: 10px 0;
            }
            .ivu-input[disabled], fieldset[disabled] .ivu-input {
                background-color: #fff;
                color: #515a6e;
            }
        }
    }
</style>
